import { HEX_COLORS as r, RATING_COLOR as d, convertToGradient as a, generateMainColorObject as t, EMERALD_COLOR as k, SLATE_COLOR as n, PRIMARY_COLOR as e, DANGER_COLOR as g, WARNING_COLOR as i, SUCCESS_COLOR as o, SECONDARY_COLOR as c, convertToRgba as O } from "../colors.js";
const b = {
  colors: {
    theme: {
      ...t(r.blackberry, "light", !0),
      gradient: a(r.blackberry),
      backgroundTheme: t(r.blackberry).dark,
      background: r.blackberry,
      text: r.blackberry,
      textOnBackground: r.white
    },
    overlay: O(r.overlay, 0.94),
    default: {
      ...t(r.white),
      gradient: a(r.white),
      background: r.white,
      text: r.white,
      textOnBackground: r.blackberry
    },
    primary: {
      ...t(e.dark, "dark"),
      gradient: a(e.light),
      background: e.dark,
      text: e.dark,
      textOnBackground: r.white
    },
    secondary: {
      ...t(c.dark, "dark"),
      gradient: a(c.light),
      background: c.dark,
      text: c.dark,
      textOnBackground: r.white
    },
    success: {
      ...t(o.dark, "dark"),
      gradient: a(o.light),
      background: o.dark,
      text: o.dark,
      textOnBackground: r.white
    },
    warning: {
      ...t(i.dark, "dark"),
      gradient: a(i.light),
      background: i.dark,
      text: i.dark,
      textOnBackground: r.white
    },
    danger: {
      ...t(g.dark, "dark"),
      gradient: a(g.light),
      background: g.dark,
      text: g.dark,
      textOnBackground: r.white
    },
    info: {
      ...t(r.white, "dark"),
      gradient: a(r.white),
      background: r.white,
      text: r.white,
      textOnBackground: e.dark,
      backgroundHovered: e.dark
    },
    // Used for AI
    slate: {
      ...t(n.dark, "dark"),
      gradient: a(n.light),
      background: n.dark,
      text: n.dark,
      textOnBackground: r.white
    },
    emerald: {
      ...t(k.dark, "dark"),
      gradient: a(k.light),
      background: k.dark,
      text: k.dark,
      textOnBackground: r.white
    },
    ratings: {
      ...t(d.dark, "dark"),
      gradient: a(d.light),
      background: d.dark,
      text: d.dark,
      textOnBackground: r.white
    }
  }
};
export {
  b as darkTheme
};
